import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04c4e343"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tabgroup" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "tab_label" };
import CurrencyPairHeader from '@/components/organisms/main/trade/currency/CurrencyPairHeader.vue';
import CurrencyPairList from '@/components/organisms/main/trade/currency/CurrencyPairList.vue';
import { useStore } from '@/store/store';
import { onMounted, ref, reactive, watch } from 'vue';
import RefreshWarn from '@/materials/atoms/RefreshWarn.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const store = useStore();
        const currency = ref(store.state.currencyPairInfo);
        const quotes = [...new Set(currency.value.map((pair) => pair.quote))];
        const tabs = ref(null);
        const state = reactive({ showLeftArrow: false, showRightArrow: false });
        const contents = [
            { label: 'ALL', groupName: 'TAB-PAIR', index: 0 },
            ...quotes.map((quote, index) => {
                return {
                    label: quote,
                    groupName: 'TAB-PAIR',
                    index: index + 1,
                };
            }),
        ];
        const updateArrowState = () => {
            const maxScrollLeft = tabs.value.scrollWidth - tabs.value.clientWidth;
            state.showLeftArrow = tabs.value.scrollLeft > 0;
            state.showRightArrow = tabs.value.scrollLeft < maxScrollLeft - 5; // Max値までいかないことがある為、バッファをとってMAX値を判定する
        };
        const currencyPairFilter = (quote) => {
            tab.value = quote;
            currency.value = store.state.currencyPairInfo.filter((pair) => quote === 'ALL' || pair.quote === quote);
        };
        const tab = ref(store.getters.symbol.quote);
        const onClickTab = (quote) => {
            currencyPairFilter(quote);
        };
        const onClickArrow = (direction) => {
            const width = tabs.value.children[0].clientWidth;
            'left' === direction && (tabs.value.scrollLeft -= width);
            'right' === direction && (tabs.value.scrollLeft += width);
            updateArrowState();
        };
        onMounted(() => {
            currencyPairFilter(tab.value);
            updateArrowState();
            tabs.value.onscroll = updateArrowState;
        });
        const clickClose = () => {
            emits('click', false);
        };
        const onChangeSymbol = (symbol) => {
            store.commit('setSymbol', symbol);
            clickClose();
        };
        watch(() => store.state.currencyPairInfo, () => currencyPairFilter(tab.value));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    (_unref(state).showLeftArrow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "arrow",
                            onClick: _cache[0] || (_cache[0] = ($event) => (onClickArrow('left')))
                        }, [
                            _createVNode(MaterialIcon, {
                                name: "arrow_back_ios",
                                class: "icon small"
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        ref_key: "tabs",
                        ref: tabs,
                        class: "tabs"
                    }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(contents, (content) => {
                            return _createElementVNode("div", {
                                key: content.index,
                                class: _normalizeClass(["tab", tab.value === content.label ? 'active' : 'non_active']),
                                onClick: ($event) => (onClickTab(content.label))
                            }, [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(content.label), 1)
                            ], 10, _hoisted_2);
                        }), 64))
                    ], 512),
                    _createElementVNode("div", {
                        class: "close_btn",
                        onClick: clickClose
                    }, [
                        _createVNode(MaterialIcon, { name: "close" })
                    ]),
                    (_unref(state).showRightArrow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "arrow",
                            onClick: _cache[1] || (_cache[1] = ($event) => (onClickArrow('right')))
                        }, [
                            _createVNode(MaterialIcon, {
                                name: "arrow_forward_ios",
                                class: "icon small"
                            })
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(CurrencyPairHeader, { class: "header" }),
                (_unref(store).state.currencyPairInfo.length !== 0)
                    ? (_openBlock(), _createBlock(CurrencyPairList, {
                        key: 0,
                        class: "lists",
                        list: currency.value,
                        onClick: onChangeSymbol
                    }, null, 8, ["list"]))
                    : _createCommentVNode("", true),
                (_unref(store).state.currencyPairInfo.length === 0)
                    ? (_openBlock(), _createBlock(RefreshWarn, {
                        key: 1,
                        class: "warn"
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
